import React from "react";
import { Header } from "@cloudscape-design/components";
import AIReasoningStream from "../common/AIReasoningStream/AIReasoningStream";
import { StreamChunk, StreamingMode } from "../common/AIReasoningStream/types";
import "./ai-reasoning-pane.scss";

interface AIReasoningPaneProps {
  chunks: StreamChunk[];
  isPolling: boolean;
  streamSpeed?: number;
  autoScroll?: boolean;
  streamingMode?: StreamingMode;
  showThinkingAnimation?: boolean;
  disableStreaming?: boolean;
  onClose: () => void;
}

const AIReasoningPane: React.FC<AIReasoningPaneProps> = ({
  chunks,
  isPolling,
  streamSpeed = 200,
  autoScroll = true,
  streamingMode = "smart",
  showThinkingAnimation = false,
  disableStreaming = false,
  onClose,
}) => {
  return (
    <div
      className={`ai-reasoning-pane ${isPolling ? "is-polling" : ""} ${
        chunks.length === 0 ? "has-no-chunks" : ""
      }`}
    >
      <div className="ai-reasoning-pane__header">
        <button
          onClick={onClose}
          className="ai-reasoning-pane__close-button"
          aria-label="Close AI Reasoning pane"
        >
          ×
        </button>
        <Header variant="h2">
          <span className={`ai-reasoning-header-text ${isPolling && chunks.length > 0 ? 'is-polling' : ''}`}>
            AI Reasoning
          </span>
        </Header>
      </div>
      <div className="ai-reasoning-pane__content">
        <AIReasoningStream
          chunks={chunks}
          streamSpeed={streamSpeed}
          autoScroll={autoScroll}
          streamingMode={streamingMode}
          showThinkingAnimation={showThinkingAnimation}
          disableStreaming={disableStreaming}
        />
      </div>
    </div>
  );
};

export default AIReasoningPane;
